import env from './environment'

const apiIp = '54.228.53.146'
export const GoogleCluster = 'https://dev-api-cluster.system.touchetv.com'
export const GoogleClusterProd = 'https://api-cluster.system.touchetv.com'

interface Settings {
  mainApi: string;
  userApi: string;
  videoProcessingApi: string;
  statsApi: string;
  actionHistoryApi: string;
  mediaUploadUrl ?: string;
  marketPlaceApi ?: string;
  playerWebUrl ?: string;
  marketPlaceSite ?: string;
  // spriteUrl: string;
}

interface SettingsList {
  localhost: Settings;
  development: Settings;
  staging: Settings;
  production: Settings;
}

const settingsList: SettingsList = {
  localhost: {
    mainApi: 'http://localhost:8082/api/v1',
    userApi: 'http://localhost:8081/api/v1',
    videoProcessingApi: 'http://localhost:8083/api/v1',
    statsApi: 'http://localhost:8084/api/v1',
    actionHistoryApi: 'http://localhost:8085/api/v1',
    marketPlaceSite: 'http://localhost:3001'
    // spriteUrl: 'http://touche-backoffice.s3-eu-west-1.amazonaws.com/ksprites'
  },
  development: {
    mainApi: `${GoogleCluster}/backoffice/api/v1`,
    userApi: `${GoogleCluster}/backoffice-user/api/v1`,
    videoProcessingApi: `${GoogleCluster}/backoffice-video-editor/api/v1`,
    statsApi: `${GoogleCluster}/backoffice-event-mapreduce/api/v1`,
    actionHistoryApi: `${GoogleCluster}/backoffice-action-history/api/v1`,
    mediaUploadUrl: `${GoogleCluster}/backoffice/gcs-upload`,
    marketPlaceApi: `${GoogleCluster}/marketplace/api/v1`,
    playerWebUrl: 'https://touche-player-dev.system.touchetv.com/',
    marketPlaceSite: 'https://marketplace-admin-dev.system.touchetv.com'
  },
  staging: {
    mainApi: `${GoogleCluster}/backoffice/api/v1`,
    userApi: `${GoogleCluster}/backoffice-user/api/v1`,
    videoProcessingApi: `${GoogleCluster}/backoffice-video-editor/api/v1`,
    statsApi: `${GoogleCluster}/backoffice-event-mapreduce/api/v1`,
    actionHistoryApi: `${GoogleCluster}/backoffice-action-history/api/v1`,
    // spriteUrl: 'http://touche-backoffice.s3-eu-west-1.amazonaws.com/ksprites'
    mediaUploadUrl: `${GoogleCluster}/backoffice/gcs-upload`,
    marketPlaceApi: `${GoogleCluster}/marketplace/api/v1`,
    playerWebUrl: 'https://touche-player-dev.system.touchetv.com/',
    marketPlaceSite: 'https://marketplace-admin-dev.system.touchetv.com'
  },
  production: {
    mainApi: `${GoogleClusterProd}/backoffice/api/v1`,
    userApi: `${GoogleClusterProd}/backoffice-user/api/v1`,
    videoProcessingApi: `${GoogleClusterProd}/backoffice-video-editor/api/v1`,
    statsApi: `${GoogleClusterProd}/backoffice-event-mapreduce/api/v1`,
    actionHistoryApi: `${GoogleClusterProd}/backoffice-action-history/api/v1`,
    mediaUploadUrl: `${GoogleClusterProd}/backoffice/gcs-upload`,
    marketPlaceApi: `${GoogleClusterProd}/marketplace/api/v1`,
    playerWebUrl: 'https://touche-player-product.system.touchetv.com/',
    marketPlaceSite: 'https://marketplace-admin-product.system.touchetv.com'
  }
}

const settings: Settings = settingsList[env]

export default settings
